import { StaticPage } from "./types";

// 静态内容页（收费规则、信息审核机制）：结构与文案对齐参考站
const fees: StaticPage = {
  slug: "fees",
  title: "收费规则",
  subtitle: "先审核后发布 · 审核不通过不收取任何费用",
  sections: [
    {
      heading: "一、免费发布",
      paragraphs: [
        "所有注册用户每天可免费发布 5 条分类信息，审核通过后在前台展示。",
        "超过免费额度的部分按 1 元/条 从账户余额扣除，不充值则当日无法继续发布。",
      ],
    },
    {
      heading: "二、置顶服务",
      paragraphs: [
        "分类信息大类置顶：5 元/天，让信息排在对应大分类的最前面。",
        "分类信息小类置顶：3 元/天，让信息排在小分类列表靠前位置。",
        "首页置顶：5 元/天，信息展示在首页推荐位，曝光量最大。",
        "置顶服务按天计费，发布信息时可自行选择置顶类型与时长，随时可购买。",
      ],
    },
    {
      heading: "三、标题增值",
      paragraphs: [
        "标题套红：2 元/条，红色标题在列表中更加醒目。",
        "标题加粗：1 元/条，加粗标题提升点击率。",
      ],
    },
    {
      heading: "四、信息刷新",
      paragraphs: [
        "1 元/次，将已发布的信息重新置顶到列表靠前位置，提升曝光与成交机会。",
      ],
    },
    {
      heading: "五、账户充值",
      paragraphs: [
        "支持在线充值，金额实时到账，充值后可随时查询余额明细。",
        "账户余额用于支付超额发布费用及各项增值服务，长期有效、不过期。",
        "如对扣费或充值有疑问，请联系平台客服核实处理。",
      ],
    },
    {
      heading: "六、审核与说明",
      paragraphs: [
        "信息发布后需平台审核，审核不通过不收取任何费用。",
        "发布违法违规、虚假误导内容的，平台将按规则删除信息并视情节限制或封禁账号。",
        "收费规则如有调整，平台将提前公示，已产生的费用不受影响。",
      ],
    },
  ],
};

const reviewMechanism: StaticPage = {
  slug: "review-mechanism",
  title: "信息审核机制",
  subtitle: "为保障平台信息真实、合法、合规，本平台实行「先审核后发布」机制",
  sections: [
    {
      heading: "一、审核范围",
      paragraphs: [
        "用户发布的分类信息、文章等内容，均需通过平台审核后方可公开展示。",
      ],
    },
    {
      heading: "二、审核流程",
      paragraphs: [
        "用户提交信息后，信息进入「待审核」状态。",
        "平台将在 1 个工作日内完成审核。",
        "审核通过的展示在前台，审核不通过的信息将退回并说明原因。",
        "用户可根据退回原因修改后重新提交。",
      ],
    },
    {
      heading: "三、审核标准",
      paragraphs: [
        "内容真实、合法、有效，不含有虚假或误导信息。",
        "不得发布违法违规、色情低俗、侵权或危害国家安全的内容。",
        "不得发布与平台服务无关的广告或垃圾信息。",
      ],
    },
    {
      heading: "四、违规处理",
      paragraphs: [
        "对发布违规信息的账号，平台将视情节采取删除信息、限制发布、封禁账号等措施，并保留向有关部门举报的权利。",
      ],
    },
  ],
};

export const staticPages: Record<string, StaticPage> = {
  [fees.slug]: fees,
  [reviewMechanism.slug]: reviewMechanism,
};

export function getStaticPage(slug: string): StaticPage | undefined {
  return staticPages[slug];
}
